import { Flex } from 'antd';
import { DefaultTheme, css, styled } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

import { PRESETS } from './AuthModal.presets';

export const getStyleAuthImage = (theme: DefaultTheme): React.CSSProperties => {
  return {
    borderRadius: `0 ${utils.rem(theme.Border.Radius.XLarge)} ${utils.rem(
      theme.Border.Radius.XLarge
    )} 0`,
    position: 'absolute',
    top: 0,
    left: 0,
    width: PRESETS.authImageWidthRem,
    height: PRESETS.authImageHeightRem,
    objectFit: 'cover',
    objectPosition: 'center',
  };
};
export const styleMainForm: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};

export const styleLinkButton: React.CSSProperties = {
  padding: '0',
  margin: '0',
};

export const getPrimaryButtonStyle = (theme: DefaultTheme): React.CSSProperties => {
  return {
    marginTop: utils.rem(theme.Spacing.Size.Small),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };
};

export const getSocialProvidersButtonStyles = (theme: DefaultTheme): React.CSSProperties => {
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };
};

export const StyledImageWrapper = styled.div(({ theme }) => {
  return css`
    position: relative;
    border-radius: 0 ${utils.rem(theme.Border.Radius.XLarge)}
      ${utils.rem(theme.Border.Radius.XLarge)} 0;
    margin-left: auto;
    min-width: ${PRESETS.authImageWidthRem};
    height: ${PRESETS.authImageHeightRem};
  `;
});

export const StyledModalSubtitle = styled.p(({ theme }) => {
  return css`
    margin-bottom: ${utils.rem(theme.Spacing.Size.Small)};
  `;
});

export const StyledAuthModalWrapper = styled.div(({ theme }) => {
  return css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    border-radius: ${utils.rem(theme.Border.Radius.XLarge)};
    justify-content: space-between;
    overflow: hidden;
  `;
});

export const StyledAuthFormWrapper = styled.div(({ theme }) => {
  return css`
    padding: ${utils.rem(theme.Spacing.Size.Medium)};
    padding-top: ${utils.rem(theme.Spacing.Size.Large)};
    width: 100%;
    display: flex;
    flex-direction: column;
    @media (min-width: ${theme.Screen.Size.Small}px) {
      padding: ${utils.rem(theme.Spacing.Size.XLarge)};
    }

    @media (min-width: ${theme.Screen.Size.Medium}px) {
      max-height: ${PRESETS.authModalMaxHeight};
    }

    & .ant-form-item-explain-error {
      line-height: ${utils.rem(theme.Spacing.Size.Large)};
    }
  `;
});

export const StyledOrDivider = styled.div(({ theme }) => {
  return css`
    margin-top: ${utils.rem(theme.Spacing.Size.MediumSmall)};
    margin-bottom: ${utils.rem(theme.Spacing.Size.MediumSmall)};
    text-align: center;
  `;
});

export const StyledSpacer = styled.div(({ theme }) => {
  return css`
    margin-top: ${utils.rem(theme.Spacing.Size.Small)};
    margin-bottom: ${utils.rem(theme.Spacing.Size.Small)};
  `;
});

export const StyledLogoSpacer = styled.div(({ theme }) => {
  return css`
    margin-bottom: ${utils.rem(theme.Spacing.Size.XLarge)};
  `;
});

export const StyledDisclaimerWrapper = styled.div(({ theme }) => {
  return css`
    text-align: center;
    margin-top: ${utils.rem(theme.Spacing.Size.XXLarge)};

    & * {
      color: ${theme.Color.Neutrals.Gray};
    }

    & a {
      text-decoration: underline;
      font-weight: 600;
    }

    @media (min-width: ${theme.Screen.Size.Medium}px) {
      margin-top: auto;
    }
  `;
});

export const StyledExtraActionsWrapper = styled.div(({ theme }) => {
  return css`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: ${utils.rem(theme.Spacing.Size.XXSmall)};
    margin-top: ${utils.rem(theme.Spacing.Size.Small)};
  `;
});

export const StyledCheckboxTransformer = styled.div`
  transform: translateY(${PRESETS.checkboxWorkaroundTranslateY});
`;

export const StyledCheckboxTextWrapper = styled.div`
  margin-top: ${PRESETS.checkboxWorkaroundMargin};
`;

export const StyledLoadingViewWrapper = styled(Flex)`
  height: 100%;
  width: 100%;
`;

export const StyledGoogleOneTapWrapper = styled.div`
  display: none;
`;

export const StyledAuthFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
  width: 100%;
`;
